"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMemoHook = void 0;
var react_1 = require("react");
var equality_1 = require("./equality");
exports.createMemoHook = function (areDepsEqual) {
    if (areDepsEqual === void 0) { areDepsEqual = equality_1.depsShallowEqual; }
    var initialResultInfo = {
        called: false,
    };
    return function (fn, deps) {
        var resultRef = react_1.useRef(initialResultInfo);
        var depsRef = react_1.useRef(deps);
        if (!resultRef.current.called) {
            resultRef.current = {
                called: true,
                data: fn(null, true),
            };
            return resultRef.current.data;
        }
        var prevDeps = depsRef.current;
        var haveDepsChanged = !areDepsEqual(prevDeps, deps);
        if (haveDepsChanged) {
            // deps have changed; recalculating output;
            resultRef.current = {
                called: true,
                data: fn((resultRef.current.called
                    ? resultRef.current.data
                    : null), !resultRef.current.called),
            };
            depsRef.current = deps;
        }
        return resultRef.current.data;
    };
};
